// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"231":"725b3cd7","711":"0dbc7d8b","776":"78f6fe13"}[chunkId] + ".chunk.css";
};